import {
  IMPACTOTHER_FETCHING,
  IMPACTOTHER_SUCCESS,
  IMPACTOTHER_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case IMPACTOTHER_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case IMPACTOTHER_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case IMPACTOTHER_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
